import { alpha } from '@mui/material/styles';
import { gray } from '../themePrimitives';

/* eslint-disable import/prefer-default-export */
export const feedbackCustomizations = {
  // Ogni gravità col suo colore (prima il template rendeva arancione ogni Alert,
  // così un errore e un successo sembravano lo stesso avviso).
  MuiAlert: {
    styleOverrides: {
      root: ({ theme, ownerState }) => {
        const tone = (theme.vars || theme).palette[ownerState.severity || 'info'];
        if (ownerState.variant === 'filled') return { borderRadius: 10 };
        return {
          borderRadius: 10,
          color: (theme.vars || theme).palette.text.primary,
          backgroundColor: alpha(theme.palette[ownerState.severity || 'info'].main, 0.08),
          border: `1px solid ${alpha(theme.palette[ownerState.severity || 'info'].main, 0.3)}`,
          '& .MuiAlert-icon': { color: tone.main },
          ...theme.applyStyles('dark', {
            backgroundColor: alpha(theme.palette[ownerState.severity || 'info'].main, 0.14),
          }),
        };
      },
    },
  },
  // Solo rotazione: l'arco che si allunga/accorcia (stroke-dasharray) gira sul thread
  // principale e si inchioda quando la pagina lavora (Meteo e Iris lo bloccano per
  // 250-500ms), facendo "scattare" lo spinner. La rotazione resta sul compositor.
  MuiCircularProgress: {
    defaultProps: { disableShrink: true },
  },
  MuiDialog: {
    styleOverrides: {
      root: ({ theme }) => ({
        '& .MuiDialog-paper': {
          borderRadius: '10px',
          border: '1px solid',
          borderColor: (theme.vars || theme).palette.divider,
        },
      }),
    },
  },
  MuiLinearProgress: {
    styleOverrides: {
      root: ({ theme }) => ({
        height: 8,
        borderRadius: 8,
        backgroundColor: gray[200],
        ...theme.applyStyles('dark', {
          backgroundColor: gray[800],
        }),
      }),
    },
  },
};
